import { render, staticRenderFns } from "./TkIntelPolicy.vue?vue&type=template&id=98f1cd30"
import script from "./TkIntelPolicy.vue?vue&type=script&lang=js"
export * from "./TkIntelPolicy.vue?vue&type=script&lang=js"
import style0 from "./TkIntelPolicy.vue?vue&type=style&index=0&id=98f1cd30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports